export const SearchResultKind = {
  Website: 'platform',
  Spot: 'spot',
  Creative: 'creative',
  FlatDeal: 'flat_deal'
} as const

export type SearchResultKind =
  (typeof SearchResultKind)[keyof typeof SearchResultKind]

export interface SearchResult {
  id: string
  name: string
  kind: SearchResultKind
  platformName: string
}
